import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserAuthGuard } from './guards/user-auth.guard';
import { RedirectToPlaystoreGuard } from './views/components/app-play-store/guards/redirect-to-playstore.guard';
import { InviteUserComponent } from './views/pages/invite-user/invite-user.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: "full"
  },  
  {
    path: 'homess',
    loadChildren: () => import('src/app/views/pages/landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'start-pagess',
    loadChildren: () => import('src/app/views/pages/start-page/start-page.module').then(m => m.StartPageModule)
  },
  {
    path: 'inviteuserss',
    component: InviteUserComponent,
  },
  {
    path: 'auth',
    loadChildren: () => import('src/app/views/pages/login-register/login-register.module').then(m => m.LoginRegisterModule),
  },
  {
    path: 'main-appss',
    loadChildren: () => import('src/app/views/pages/main-app/main-app.module').then(m => m.MainAppModule),
  },
  {
    path: 'simrs',
    loadChildren: () => import('src/app/views/pages/simrs/simrs.module').then(m => m.SimrsModule),
  },
  {
    path: 'androidss',
    canActivate: [RedirectToPlaystoreGuard],
    component: RedirectToPlaystoreGuard,
    data: {
      externalUrl: 'https://play.google.com/store/apps/details?id=id.ikd.screenout'
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
